import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBroadcast = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 1 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M1.5 6.117c0-1.75.73-3.332 1.905-4.475l.697.716A5.228 5.228 0 0 0 2.5 6.118c0 1.47.614 2.801 1.612 3.768l-.696.718A6.228 6.228 0 0 1 1.5 6.117Zm10.857 0a4.18 4.18 0 0 0-1.278-3.005l-.698.717a3.18 3.18 0 0 1 .976 2.288c0 .894-.372 1.704-.98 2.294l.696.718a4.182 4.182 0 0 0 1.284-3.012Zm-8.714 0c0-1.172.488-2.233 1.272-2.999l.699.716a3.182 3.182 0 0 0-.97 2.283c0 .894.371 1.704.98 2.294l-.696.718a4.183 4.183 0 0 1-1.285-3.012Zm3.229 0c0-.584.491-1.082 1.128-1.082.637 0 1.129.498 1.129 1.082C9.129 6.701 8.637 7.2 8 7.2s-1.128-.498-1.128-1.082ZM8 4.035c-1.162 0-2.128.919-2.128 2.082C5.872 7.281 6.838 8.2 8 8.2c1.162 0 2.129-.918 2.129-2.082 0-1.163-.967-2.082-2.129-2.082Zm.427 5.791L8 9.123l-.427.703-2.379 3.914-.461.76h6.535l-.462-.76-2.379-3.914ZM8 11.05l1.49 2.45H6.51L8 11.049Zm6.5-4.932a6.227 6.227 0 0 0-1.896-4.467l-.699.715A5.227 5.227 0 0 1 13.5 6.117a5.229 5.229 0 0 1-1.617 3.774l.694.72A6.229 6.229 0 0 0 14.5 6.117Z",
		clipRule: "evenodd"
	})
});
export default SvgBroadcast;
